import { getAccessToken, getSoDetail } from "../../store/visitForm1";
import { createFetch } from "../../utils";

export const registerLoginInfo = ({ token, expired, soId }) => ({
  type: getAccessToken,
  payload: {
    token,
    expired,
    soId,
  },
});

export const getSalesOrderDetail = () => async (dispatch, getState) => {
  const { accessToken, soId } = getState().vf1;
  const soDetail = await createFetch({
    path: `vf1/so/${soId}`,
    accessToken,
    method: "GET",
  });

  dispatch({
    type: getSoDetail,
    payload: soDetail.record,
  });
};

export const editGuestDetail = async (data, guestId, callback) => {
  const getLocalStorage = JSON.parse(localStorage.getItem("persist:root"));
  const getAccessToken = JSON.parse(getLocalStorage.vf1);
  const accessToken = getAccessToken.accessToken;
  const guestDetail = await createFetch({
    path: `vf1/edit/${guestId}`,
    method: "PATCH",
    body: data,
    accessToken,
  });
  callback();
  return guestDetail;
};

export const guestAllocation = async (data) => {
  const guestDetail = await createFetch({
    path: "vf1/allocate",
    method: "POST",
    body: data,
  });
  return guestDetail;
};
export default null;
